import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';
import URLSanitizer from '../../services/url-sanitizer';
import APP_ROUTES from '../../constants/app-routes';
import APP_DEFAULTS from '../../constants/app-defaults';
import SecurityPaymentIcons from '../security-icons';

import noImage from '../../images/no-image-small.png';
import LineItem from './line-item';

class CartShow extends Component {
    constructor(props) {
        super(props);

        this.emptyCart = this.emptyCart.bind(this);
        this.doCheckout = this.doCheckout.bind(this);

        document.title = this.props.intl.formatMessage({ id: 'shopping-cart', defaultMessage: 'Shopping Cart' });
    }

    componentDidMount() {
        if (this.props.order.created_at && !this.props.order.addingProductToCart) {
            this.props.refreshOrder(this.props.order, this.props.locale.currentLocale);
        }
        this.props.setCurrentCheckoutStep();
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'shopping-cart', defaultMessage: 'Shopping Cart' });
        }
    }

    groupItemsByCategory = (items) => {
        const groups = {};
        const result = [];
        items.forEach((elem) => {
            if (groups[elem.shipping_category.name]) {
                groups[elem.shipping_category.name].push(elem);
            } else {
                groups[elem.shipping_category.name] = [elem];
            }
        });
        const categories = Object.keys(groups);
        categories.forEach((cat) => {
            if (cat !== 'Default') {
                result.push(...groups[cat]);
            }
        });
        if (groups.Default) {
            result.push(...groups.Default);
        }
        return result;
    }

    emptyCart() {
        this.props.emptyCart(this.props.order, this.props.locale.currentLocale);
    }

    doCheckout() {
        this.props.doCheckout(this.props.order, this.props.locale.currentLocale);
    }

    render() {
        let lineItems = [];
        const { stores, lineItemsError } = this.props;

        if (this.props.order.state !== 'complete') {
            lineItems = this.groupItemsByCategory(this.props.order.line_items);
        }

        const itemHasError = (idItem) => lineItemsError && lineItemsError.length > 0
            // eslint-disable-next-line eqeqeq
            && !!lineItemsError.find((idItemError) => idItem == idItemError);

        const existItemsWithError = lineItems && lineItems.length > 0
            && !!lineItems.find((lineItem) => itemHasError(lineItem.id));

        let renderString = (
            <div className="row text-center cart-empty-block">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h4 className="cart-empty-text margin-top-50 margin-top-xs-20">
                        <FormattedMessage
                            id="cart-is-empty"
                            defaultMessage="Your cart is empty."
                        />
                    </h4>
                    <br />
                    <h4 className="cart-empty-text">
                        <FormattedMessage
                            id="add-few-products-to-cart"
                            defaultMessage="Add few products to cart."
                        />
                    </h4>
                    <Link
                        className="button-corner-inverter cart-button-with-glyph margin-top-50"
                        to={APP_ROUTES.homePageRoute}
                    >
                        <span className="glyphicon glyphicon-chevron-left" />
                        <FormattedMessage id="go-shopping" defaultMessage="Go Shopping" />
                    </Link>
                </div>
            </div>
        );

        if (lineItems.length > 0) {
            const lineItemList = stores && stores.filter((store) => lineItems.findIndex((item) => item.attributes.store_id === store.id) !== -1)
                .map((store, index) => (
                    <div key={index}>
                        <div className="row cart-store-title">
                            <FormattedMessage id="products-from" defaultMessage="Products from: " />
                            {store.name}
                        </div>
                        <div>
                            {lineItems.filter((item) => item.attributes.store_id === store.id)
                                .map((lineItem, idx) => {
                                    const variantImage = lineItem.variant && lineItem.variant.images[0];

                                    let imageUrl = '';

                                    if (variantImage) {
                                        imageUrl = URLSanitizer.makeAbsolute(variantImage.attributes.styles[2].url);
                                    } else {
                                        imageUrl = noImage;
                                    }

                                    const productSlug = lineItem.variant && lineItem.attributes.slug;

                                    return (
                                        <LineItem
                                            idx={idx}
                                            key={`lineitem-${idx}`}
                                            order={this.props.order}
                                            lineItem={lineItem}
                                            lineItems={lineItems.filter((item) => item.attributes.store_id === store.id)}
                                            lineItemsCount={lineItems.length}
                                            imageUrl={imageUrl}
                                            productSlug={productSlug}
                                            destroyLineItem={this.props.destroyLineItem}
                                            destroyDataExtra={this.props.destroyDataExtra}
                                            changeQuantity={this.props.changeQuantity}
                                            emptyCart={this.props.emptyCart}
                                            disablingPlus={this.props.disablingPlus}
                                            locale={this.props.locale}
                                            currentZone={this.props.currentZone}
                                            errorShipping={itemHasError(lineItem.id)}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                ));

            lineItems.map((lineItem, idx) => {
                const variantImage = lineItem.variant && lineItem.variant.images[0];

                let imageUrl = '';

                if (variantImage) {
                    imageUrl = URLSanitizer.makeAbsolute(variantImage.attributes.styles[2].url);
                } else {
                    imageUrl = noImage;
                }

                const productSlug = lineItem.variant && lineItem.variant.attributes.slug;

                return (
                    <LineItem
                        idx={idx}
                        key={`lineitem-${idx}`}
                        order={this.props.order}
                        lineItem={lineItem}
                        lineItems={lineItems}
                        lineItemsCount={lineItems.length}
                        imageUrl={imageUrl}
                        productSlug={productSlug}
                        destroyLineItem={this.props.destroyLineItem}
                        destroyDataExtra={this.props.destroyDataExtra}
                        changeQuantity={this.props.changeQuantity}
                        emptyCart={this.props.emptyCart}
                        locale={this.props.locale}
                        errorShipping={itemHasError(lineItem.id)}
                    />
                );
            });

            renderString = (
                <div>
                    <div className="row actions-top-cart">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left margin-top-20 actions-top-cart__contain">
                            <Link
                                className="button-corner-inverter cart-button-with-glyph margin-left-40 actions-top-cart__contain__btn"
                                to={APP_ROUTES.homePageRoute}
                            >
                                <span className="glyphicon glyphicon-chevron-left" />
                                <FormattedMessage
                                    id="continue-shopping"
                                    defaultMessage="Continue Shopping"
                                />
                            </Link>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right margin-top-20 actions-top-cart__contain">
                            <button
                                type="button"
                                className="button-corner cart-button-with-glyph margin-right-40 actions-top-cart__contain__btn"
                                onClick={this.doCheckout}
                            >
                                <FormattedMessage
                                    id="proceed-to-checkout"
                                    defaultMessage="Proceed to Checkout"
                                />
                            </button>
                        </div>
                    </div>
                    { existItemsWithError && (
                        <div className="row shipping-address-problems">
                            <i className="pe-7s-close-circle" />
                            <FormattedMessage
                                id="shipping-address-problems"
                                defaultMessage="There are problems shipping some products to the selected address. Please check your products."
                            />
                        </div>
                    ) }
                    <div className="row cart-items-section">
                        <div className="cart-items-table">
                            <div className="row cart-items-table-title">
                                <div
                                    className="col-lg-6 col-md-6 col-sm-12 col-xs-12 cart-items-table-title-text"
                                >
                                    <i className="pe-7s-cart" />
                                    <FormattedMessage id="cart" defaultMessage="Cart" />
                                </div>
                                <div className="col-lg-6 col-md-6 hidden-sm hidden-xs">
                                    <div className="row cart-table-title-right">
                                        <div
                                            className="col-lg-offset-2 col-lg-3 col-md-offset-2 col-md-3 col-sm-offset-2 col-sm-3 col-xs-offset-2 col-xs-3"
                                        >
                                            <FormattedMessage
                                                id="unit-price"
                                                defaultMessage="Unit price"
                                            />
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                            <FormattedMessage
                                                id="quantity"
                                                defaultMessage="Quantity"
                                            />
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                            <FormattedMessage
                                                id="subtotal"
                                                defaultMessage="Subtotal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {lineItemList}
                            <div className="row footer-table">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" />
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 inner-table">
                                    <div className="row">
                                        <div className="col-lg-offset-2 col-lg-6 col-md-offset-2 col-md-6 col-sm-offset-1 col-sm-6 col-xs-8">
                                            <span className="subtotal-title">
                                                <FormattedMessage
                                                    id="subtotal"
                                                    defaultMessage="Subtotal"
                                                />
                                                {' ( '}
                                                {this.props.order.item_count}
                                                {' '}
                                                <FormattedMessage
                                                    id="products"
                                                    defaultMessage="Products"
                                                />
                                                {' )'}
                                            </span>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-5 col-xs-4">
                                            <span className="result">{this.props.order.display_item_total}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container cart-buttons-row">
                            <div className="row justify-content-end">
                                {/* <div className="col-sm-8">
                                    <a
                                        className="button-primary button-green empty-cart"
                                        onClick={this.emptyCart}
                                    >
                                        <FormattedMessage
                                            id="empty-cart"
                                            defaultMessage="Empty Cart"
                                        />
                                    </a>
                                </div> */}
                                <div className="col-4 text-right">
                                    <button
                                        type="button"
                                        className="button-primary button-white"
                                        onClick={this.doCheckout}
                                    >
                                        <FormattedMessage
                                            id="proceed-to-checkout"
                                            defaultMessage="Place Order"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <Layout>
                <div className="cart-section">
                    <div className="container">
                        <div className="cart-section-heading">
                            <FormattedMessage id="shopping-cart" defaultMessage="Shopping Cart" />
                        </div>
                        <section className="cart-table-info">
                            <div className="row text-center">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <ul className="list-inline">
                                        <li>
                                            <Link
                                                className="cart-list-inline-button"
                                                to={APP_ROUTES.shipping}
                                            >
                                                <FormattedMessage
                                                    id="shipping-policies"
                                                    defaultMessage="Shipping Policies and Charges"
                                                />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                className="cart-list-inline-button"
                                                to={APP_ROUTES.returns}
                                            >
                                                <FormattedMessage
                                                    id="return-policy"
                                                    defaultMessage="Return Policy"
                                                />
                                            </Link>
                                        </li>
                                        <li>
                                            <a
                                                role="button"
                                                className="cart-list-inline-button"
                                                href={`mailto:${APP_DEFAULTS.info_email}`}
                                            >
                                                <FormattedMessage
                                                    id="costumer-service"
                                                    defaultMessage="Customer Service"
                                                />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        {renderString}
                        <div className="row text-center" style={{ marginTop: '20px' }}>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <SecurityPaymentIcons />
                            </div>
                        </div>

                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(CartShow);



/** WEBPACK FOOTER **
 ** ./src/components/cart/show.jsx
 **/